<template>
    <layout title="Contract Loads">
        <div class="lg:grid lg:grid-cols-12 lg:gap-x-10">
            <section class="bg-blue-50 p-8 lg:col-span-6">
                <h3 class="text-2xl font-medium text-blue-900">Contract Load Search</h3>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <label class="text-xs text-gray-500 pl-1">Contract</label>
                    <input v-model="searchOptions.contract" type="text" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full p-3 font-mono border-gray-300 rounded-md">
                </div>
                <div class="mt-4 relative rounded-md shadow-sm">
                    <label class="text-xs text-gray-500 pl-1">Load</label>
                    <input v-model="searchOptions.load" type="text" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full p-3 font-mono border-gray-300 rounded-md">
                </div>
                <button @click="search()" class="mt-4 flex items-center justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-lg">
                    Search
                </button>
            </section>
            <section class="lg:col-span-6 flex items-center bg-gray-100">
                <div v-if="isSearching && Object.keys(contractLoad).length <= 0" class="text-xl text-center w-full">No results found...</div>
                <div v-if="Object.keys(contractLoad).length > 0" class="flex w-full justify-center">
                    <div class="border border-gray-200 w-1/2 ml-8 mr-8">
                        <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Invoice Number</div>
                        <div @click="showInvoice(contractLoad.invoice)" class="bg-white p-2 text-center text-gray-700 text-lg font-medium font-mono text-blue-600 cursor-pointer">{{ contractLoad.invoice_number }}</div>
                    </div>
                    <div class="border border-gray-200 w-1/2 ml-8 mr-8">
                        <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Ship Date</div>
                        <div class="bg-white p-2 text-center text-gray-700 text-lg font-medium font-mono">{{ contractLoad.ticket_date | niceDate }}</div>
                    </div>
                    <div class="border border-gray-200 w-1/2 mr-8">
                        <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Quantity</div>
                        <div class="bg-white p-2 text-center text-gray-700 text-lg font-medium font-mono">{{ contractLoad.net_weight | numberInThousands }}</div>
                    </div>
                </div>
            </section>
        </div>
        <contract-invoice :invoice="contractLoad.invoice"></contract-invoice>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import ContractInvoice from "@/Components/CustomerContracts/ContractInvoice";

export default {
    components: {Layout, ContractInvoice},
    props: {
        contractLoad: {
            type: [Object, Array],
            default: {}
        },
    },
    data() {
        return {
            searchOptions: {},
            isSearching: false,
        }
    },
    methods: {
        showInvoice(item) {
            this.$eventBus.$emit('show-contract-invoice', item)
        },
        search() {
            let searchParams = {}
            if (this.searchOptions.load !== '' && this.searchOptions.load > 0) {
                searchParams.load = this.searchOptions.load
            }
            if (this.searchOptions.contract !== '') {
                searchParams.contract = this.searchOptions.contract
            }
            this.$inertia.get('contract-loads', searchParams, { preserveState: true })
            this.isSearching = true
        }
    }
}
</script>
